import { supabase } from '../../lib/supabase';
import { ActionItem, ActionItemStatus } from '../../types/actionItems';

export const actionItemsService = {
  async getActionItems(userId: string) {
    const { data, error } = await supabase
      .from('action_items')
      .select(`
        *,
        meeting:meeting_id (
          title
        )
      `)
      .eq('user_id', userId);

    if (error) {
      console.error('Error fetching action items:', error);
      throw error;
    }

    return data.map(item => ({
      ...item,
      status: item.status as ActionItemStatus
    })) as ActionItem[];
  },

  async getActionItem(id: string, userId: string) {
    const { data, error } = await supabase
      .from('action_items')
      .select(`
        *,
        meeting:meeting_id (
          title
        )
      `)
      .eq('id', id)
      .eq('user_id', userId)
      .single();

    if (error) {
      console.error('Error fetching action item:', error);
      throw error;
    }

    return {
      ...data,
      status: data.status as ActionItemStatus
    } as ActionItem;
  },

  async createActionItem(userId: string, actionItem: Omit<ActionItem, 'id' | 'user_id'>) {
    const { data, error } = await supabase
      .from('action_items')
      .insert({ ...actionItem, user_id: userId })
      .select()
      .single();

    if (error) {
      console.error('Error creating action item:', error);
      throw error;
    }

    return data as ActionItem;
  },

  async updateActionItem(id: string, userId: string, updates: Partial<ActionItem>) {
    const { data, error } = await supabase
      .from('action_items')
      .update(updates)
      .eq('id', id)
      .eq('user_id', userId)
      .select()
      .single();

    if (error) {
      console.error('Error updating action item:', error);
      throw error;
    }

    return data as ActionItem;
  },

  async deleteActionItem(id: string, userId: string) {
    const { error } = await supabase
      .from('action_items')
      .delete()
      .eq('id', id)
      .eq('user_id', userId);

    if (error) {
      console.error('Error deleting action item:', error);
      throw error;
    }
  }
};
